<div class="container" id="translate-content">
    <main class="row eui-u-flex-justify-content-center">
        <article class="col-md-8">
            <button euiButton (click)="translate()">
                <eui-icon-svg icon="eui-language-selector" />
                {{ "actions.translate" | translate }}
            </button>
            <div class="eui-u-flex eui-u-flex-justify-content-center">
                <h1>About</h1>
            </div>
            <p>
                The Commission provides a searchable online database of RASFF notifications
                classified as alert, information notification or border rejection as part of its
                RASFF Window application. As it is necessary to strike the balance between openness
                and the protection of commercial information, the trade names and the identity of
                individual companies may not be made available by the
                <a
                    href="https://food.ec.europa.eu/safety/rasff-food-and-feed-safety-alerts/members-rasff-network_en"
                    target="_blank"
                    aria-label="Open page about members of the RASFF network in a new window"
                    role="link"
                    rel="noopener"
                >
                    members of the RASFF network.</a
                >
                <br /><br />
                This is not detrimental to consumer protection, as a RASFF notification implies that
                all required measures have been or are in the process of being taken. The public
                must be aware that the Commission is not in a position to release more information
                than that published here. However, in exceptional circumstances where the protection
                of human health requires greater transparency, the Commission takes the appropriate
                action through its usual communication channels.
                <br /><br />
                The Commission informs the authorities of third countries of notifications
                concerning products manufactured in, distributed to or dispatched from these
                countries. However, the fact that a country is mentioned as the origin of a product
                does not necessarily imply that the identified hazard(s) originated in the country
                concerned.
                <br /><br />
                The Commission cannot and does not take any responsibility for the accuracy of the
                information in the RASFF Window application. The information is published as it has
                been received from the official contact points in the Member States/EEA-EFTA
                countries. In the event that further information received from a contact point
                regarding an already published notification leads to modification or withdrawal of
                the notification, these changes are reflected in RASFF Window. If appropriate the
                Commission shall withdraw the notification concerned applying the
                <a
                    href="https://eur-lex.europa.eu/eli/reg/2017/625/2022-01-28"
                    target="_blank"
                    aria-label="Open page about rules in a new window"
                    role="link"
                    rel="noopener"
                >
                    rules</a
                >
                accordingly.
            </p>
        </article>
    </main>
</div>
